import modal from './modal';
import actions from './actions';

export default {
    ...modal,
    ...actions,
};
